import {mapGetters, mapActions, mapMutations} from 'vuex';
import Header from '@/components/header/index.vue'
import leftBar from '@/components/left-bar/index.vue'
import TableOptions from '@/components/table/options/index.vue'
import Table from '@/components/table/list/index.vue'
import popupManufacturer from '@/components/popups/catalog/manufacturer/index.vue'
import pagination from '@/components/pagination/index.vue'
import paginationMixin from '@/mixins/pagination/index.js'

export default {
    components:{
        Header,
        leftBar,
        TableOptions,
        Table,
        popupManufacturer,
        pagination
    },
    mixins: [paginationMixin],
    data(){
        return{
            fields:[
                {
                    key: 'id',
                    label: 'ID'
                },
                {
                    key:'title',
                    label:'Название',
                },
                {
                    key:'status',
                    label:'Cтатус',
                },
                {
                    key:'sort',
                    label:'Сорт',
                },
            ],
            items:[],
            selectedItem: null,
            showManufacturerPopup: null,
        }
    },
    computed:{
        ...mapGetters({
            menuHide:'config/menuHide',
            manufacturers:'catalog/manufacturers',
        })
    },
    watch:{
        manufacturers(e){
            this.items = []
            e.data.map(item=>{
                this.items.push({id:item.id, 'title': item.title, 'status': Boolean(item.status), 'sort': item.sort})
            })
            this.res = e
        },
        page(e) {
            this.getManufacturers({page: e, per_page: this.per_page});
        },
        per_page(e) {
            this.getManufacturers({page: this.page, per_page: e});
        }
    },
    created() {
        this.toggleLoadingStatus(true);
        this.getManufacturers({page: 1, per_page: this.per_page}).then(()=>{
            this.toggleLoadingStatus(false);
        })
    },
    methods:{
        getSearchInfo(data){
            if(this.activeStatus !== 0){
                if(data.query){
                    this.getManufacturers({[data.type]: data.query,page: this.page, per_page: this.per_page, customer_group_id: this.activeStatus});
                }else{
                    this.getManufacturers({page: this.page, per_page: this.per_page, customer_group_id: this.activeStatus});
                }
            }else{
                if(data.query){
                    this.getManufacturers({[data.type]: data.query,page: this.page, per_page: this.perPage});
                }else{
                    this.getManufacturers({page: this.page, perpage: this.perPage});
                }
            }
        },
        getAllItemsInTable(){
            this.selectedItem = this.items;
            this.$refs.tableComponent.getAllItemsInTable();
        },
        sendManufacturer(item){
            this.addManufacturer(item).then(res=>{
                if(res.status){
                    this.items = [];
                    this.$toasted.success('Производитель успешно удален', {
                        duration: 3000
                    });
                    this.showManufacturerPopup = false;
                    this.getManufacturers();
                }
            });
        },
        changeManufacturer(item){
            this.editManufacturer(item).then(res=>{
                if(res.status){
                    this.items = [];
                    this.$toasted.success('Производитель успешно изменен', {
                        duration: 3000
                    });
                    this.showManufacturerPopup = false;
                    this.getManufacturers();
                }
            });
        },
        selectItem(item){
            if(item.length){
                this.selectedItem = item;
            }else{
                this.selectedItem = null;
            }
        },
        toggleStatus(item){
            const payload = {
                id: item.id,
                data:{
                    title:item.title,
                    status:item.status
                }
            }
            this.editManufacturer(payload)
        },
        editClickManufacturer(item){
            this.showManufacturer(item.id)
            this.showManufacturerPopup = true;
        },
        removeItem(id){
            this.removeManufacturer(id).then(res=>{
                if(res.status){
                    this.items = [];
                    this.getManufacturers();
                    this.$toasted.success('Производитель успешно удален',{
                        duration : 3000
                    });
                    this.showManufacturerPopup = false;
                }
            })
        },
        ...mapActions({
            getManufacturers:'catalog/getManufacturers',
            showManufacturer:'catalog/showManufacturer',
            editManufacturer:'catalog/editManufacturer',
            addManufacturer:'catalog/addManufacturer',
            removeManufacturer:'catalog/removeManufacturer',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
        })
    }
}
